import AppRoute from "models/AppRoute"
import { Guid } from "@/types"

export enum CancelInvoicesMode {
    single = "single",
    collective = "collective"
}

interface ICancelInvoicesRouteParams {

}

interface ICancelInvoicesRouteQuery {
    reservationId: Guid
    invoiceIds: Guid[]
}

const CancelInvoicesRoute = new AppRoute<ICancelInvoicesRouteParams, ICancelInvoicesRouteQuery>({
    route: "/cancel-invoices",
    navbar: true,
    authRequired: true,
    minWidth: "auto",
})

export default CancelInvoicesRoute
